export default {
  title: '{{company}} hat deine Abholzeit geändert',
  new_time_label: 'Neue Zeit',
};
